/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, memo } from 'react';
import { connect } from 'react-redux';
import {
  bool, shape, arrayOf, func,
} from 'prop-types';
import { isEmpty, uniq, uniqBy } from 'lodash';
import { Divider, FormControlLabel, Checkbox } from '@material-ui/core';

import SectionInfoRow from '../../components/SectionInfoRow';
import AttributesFilter from '../../components/AttributesFilter';
import SelectProducts from '../../components/SelectProducts';
import ProductsPagination from '../../../../components/ProductsPagination';

import {
  mapProductList,
  getFilterWithoutProductFilter,
  mapFrontEndPrefixToFilters,
  getSplitedFilterByQuery,
  getProductCompoundSearchFilter,
} from '../../utils/mappers';

import { defaultPagination } from '../../utils/defaultData';

import {
  productsFiltersSelector,
  productsMappedFiltersSelector,
  productSectionSelectedProductsFilterSelector,
} from '../../selectors';

import {
  updateProductsFilters,
  fetchProductList,
  setProductsSectionProductFilter,
  fetchProductSectionProductsByIds,
  setSelectedProductsSectionProductList,
  setProductSectionProductsInIds,
  updateProductSectionLoadedProductsIn,
  setSelectedProductSectionProductsFilters,
  completeProductSectionProductList,
} from '../../../../actions/influencer';

import {
  fetchAttributeOptions,
} from '../../../../actions/productAttribute';

import IntlMessages from '../../../../util/IntlMessages';

const ProductsContainer = memo((props) => {
  const [compoundSearch, setCompoundSearch] = useState(null);
  const [leftSidePagination, setLeftSidePagination] = useState(defaultPagination);

  const {
    influencer, productsFilters, fetchingScopeCategoriesByIds,
    categoriesAttributesFetching, fetchingAttributeOptions, scopeCategoriesByIds,
    mappedFilters, influencerProduct, productList, fetchedOne,
    selectedProductsFilters, disabled,
  } = props;

  useEffect(() => {
    const productsInFilter = selectedProductsFilters.find(f => f.field === 'id');
    const productsInIds = productsInFilter ? productsInFilter.value : [];

    if (fetchedOne && !isEmpty(productsInIds)) {
      props.updateProductSectionLoadedProductsIn([...productsInIds.map(p => ({ id: p }))]);
      props.setProductSectionProductsInIds(productsInIds);
    }
  }, [fetchedOne]);

  const handleSelectProductsDialogClose = () => {};
  const handleProductDialogApplyFilterChange = () => {};

  const handleSelectProductsDialogOpen = () => {
    const physicalCategoriesIds = scopeCategoriesByIds
      .map(c => c.virtualParams.mappedCategories).flat();
    const productFilters = mapFrontEndPrefixToFilters(getFilterWithoutProductFilter(mappedFilters));
    let newProductFilter = [];

    if (!isEmpty(physicalCategoriesIds)) {
      newProductFilter = [{
        group: [{
          field: 'categories',
          value: physicalCategoriesIds,
          operator: 'in',
        }],
      }];
      props.setProductsSectionProductFilter([...newProductFilter]);
    }

    props.fetchProductList({
      viewMode: 'frontendWithParams',
      compoundSearch,
      pagination: leftSidePagination,
      filter: [...newProductFilter.flat(), ...productFilters].flat(),
    });
  };

  const handleSearchSubmit = (query) => {
    const splitedFilter = getSplitedFilterByQuery(query);
    const newCompoundSearch = getProductCompoundSearchFilter(splitedFilter.queryString.join(', '));
    const physicalCategoriesIds = scopeCategoriesByIds
      .map(c => c.virtualParams.mappedCategories).flat();
    let newProductFilter = [];

    setCompoundSearch(newCompoundSearch);
    setLeftSidePagination(defaultPagination);

    const productsGroupFilter = !isEmpty(splitedFilter.productIds)
      ? [{
        group: [{
          field: 'id',
          value: uniq(splitedFilter.productIds),
          operator: 'in',
        }],
      }]
      : [];

    if (!isEmpty(physicalCategoriesIds)) {
      newProductFilter = [{
        group: [{
          field: 'categories',
          value: physicalCategoriesIds,
          operator: 'in',
        }],
      }];
    }

    const newFilters = getFilterWithoutProductFilter(mappedFilters);
    const filtersWithPrefix = mapFrontEndPrefixToFilters(newFilters);

    const productSearchFilter = [
      ...filtersWithPrefix,
      ...influencerProduct.productSection.productFilter,
    ];

    props.fetchProductList({
      viewMode: 'frontendWithParams',
      compoundSearch: newCompoundSearch,
      pagination: defaultPagination,
      searchFilter: {},
      filter: [...productSearchFilter, ...newProductFilter, ...productsGroupFilter].flat(),
    });
  };

  const handleSelectedListChange = (selectedProductList, key) => {
    props.setSelectedProductsSectionProductList({
      ...influencerProduct.productSection.selectedProductList,
      [key]: selectedProductList,
    });

    props.setProductSectionProductsInIds(selectedProductList.map(p => p.id));
    props.updateProductSectionLoadedProductsIn(selectedProductList);
  };

  const handleDialogSelectClick = () => {
    const { selectedProductList } = influencerProduct.productSection;
    if (!isEmpty(selectedProductList.in)) {
      const productsInIds = selectedProductList.in.map(p => p.id);
      const newFilters = [{
        id: new Date().toString(),
        field: 'id',
        operator: 'in',
        value: productsInIds,
      }];
      props.setSelectedProductSectionProductsFilters(newFilters);
    }
  };

  const onLeftSidePaginate = ({ selected }) => {
    const updatedPagination = {
      ...leftSidePagination,
      page: selected + 1,
    };

    const newFilters = getFilterWithoutProductFilter(mappedFilters);
    const filtersWithPrefix = mapFrontEndPrefixToFilters(newFilters);

    const productSearchFilter = [
      ...filtersWithPrefix,
      ...influencerProduct.productSection.productFilter,
    ];

    setLeftSidePagination(updatedPagination);
    props.fetchProductList({
      viewMode: 'frontendWithParams',
      compoundSearch,
      filter: productSearchFilter,
      pagination: updatedPagination,
      searchFilter: {},
    });
  };

  const getSearchSuffix = () => (
    <FormControlLabel
      className="label-clear checkbox-sm"
      control={(
        <Checkbox
          checked
          disabled
          onChange={handleProductDialogApplyFilterChange}
          color="primary"
        />
      )}
      label={<IntlMessages id="influencer.selectProductsDialog.search.checkbox.applyFilter" />}
    />
  );

  const loading = (
    fetchingScopeCategoriesByIds
    || categoriesAttributesFetching
  );

  const listIn = uniqBy([
    ...influencerProduct.productSection.productsByIdsForIn,
  ], 'id');

  const mappedListIn = mapProductList(listIn);

  return (
    <>
      <SectionInfoRow
        label="Product link"
        url={`americanoutlets.com/influencer/${influencer.page.storeName}/products`}
        title={<IntlMessages id="influencer.products.title" />}
      />
      <Divider className="influencers-row-divider" />
      <div className="section-subtitle">
        <IntlMessages id="influencer.products.filters.subtitle" />
      </div>
      <AttributesFilter
        updateFilters={props.updateProductsFilters}
        filters={productsFilters}
        loading={loading}
        fetchAttributeOptions={props.fetchAttributeOptions}
        fetchingAttributeOptions={fetchingAttributeOptions}
        disabled={disabled}
      />
      <Divider className="influencers-row-divider" />
      <SelectProducts
        onOpen={handleSelectProductsDialogOpen}
        onClose={handleSelectProductsDialogClose}
        sourceList={mapProductList(productList) || []}
        listIn={mappedListIn}
        listNin={[]}
        listInIds={influencerProduct.productSection.productsInIds || []}
        listNinIds={[]}
        completingCategoryProductsList={
          influencerProduct.productSection.completingCategoryProductsList
        }
        fetchProductsByIdsStarted={influencerProduct.productSection.fetchProductsByIdsStarted}
        fetchProductsByIds={props.fetchProductSectionProductsByIds}
        onSearchSubmit={handleSearchSubmit}
        onSelectedListChange={handleSelectedListChange}
        onDialogSelectClick={handleDialogSelectClick}
        completeProductList={props.completeProductSectionProductList}
        operator="in"
        maxSelected={50}
        loading={{
          leftList: influencerProduct.influencerFetchProductListStart,
          rightList: influencerProduct.productSection.fetchProductsByIdsStarted,
        }}
        leftPagination={(
          <ProductsPagination
            containerClassName="pagination-sm pagination-abs"
            onPaginate={onLeftSidePaginate}
            product={{
              pages: influencerProduct.pages,
              total: influencerProduct.total,
            }}
            pagination={leftSidePagination}
          />
        )}
        search={{
          suffix: getSearchSuffix(),
        }}
        disabled={disabled}
      />
    </>
  );
});

ProductsContainer.propTypes = {
  influencer: shape().isRequired,
  productsFilters: arrayOf(shape()).isRequired,
  scopeCategoriesByIds: arrayOf(shape()).isRequired,
  mappedFilters: arrayOf(shape()).isRequired,
  influencerProduct: shape().isRequired,
  productList: arrayOf(shape()).isRequired,
  selectedProductsFilters: arrayOf(shape()).isRequired,

  fetchingScopeCategoriesByIds: bool.isRequired,
  categoriesAttributesFetching: bool.isRequired,
  fetchingAttributeOptions: bool.isRequired,
  fetchedOne: bool.isRequired,
  disabled: bool.isRequired,

  updateProductsFilters: func.isRequired,
  fetchAttributeOptions: func.isRequired,
  fetchProductList: func.isRequired,
  setProductsSectionProductFilter: func.isRequired,
  fetchProductSectionProductsByIds: func.isRequired,
  setSelectedProductsSectionProductList: func.isRequired,
  setProductSectionProductsInIds: func.isRequired,
  updateProductSectionLoadedProductsIn: func.isRequired,
  setSelectedProductSectionProductsFilters: func.isRequired,
  completeProductSectionProductList: func.isRequired,
};

const mapStateToProps = state => ({
  influencer: state.influencer.item,
  productsFilters: productsFiltersSelector(state.influencer.item),
  mappedFilters: productsMappedFiltersSelector(state.influencer.item),
  selectedProductsFilters: productSectionSelectedProductsFilterSelector(state.influencer.item),
  influencerProduct: state.influencer.product,
  productList: state.influencer.product.list,
  fetchedOne: state.influencer.fetchedOne,

  fetchingScopeCategoriesByIds: state.scopeCategory.fetchingScopeCategoriesByIds,
  scopeCategoriesByIds: state.scopeCategory.categoriesByIds,

  categoriesAttributesFetching: state.productAttribute.categoriesAttributesFetching,
  fetchingAttributeOptions: state.productAttribute.fetchingAttributeOptions,
});

const actionCreators = {
  updateProductsFilters,
  fetchAttributeOptions,
  fetchProductList,
  setProductsSectionProductFilter,
  fetchProductSectionProductsByIds,
  setSelectedProductsSectionProductList,
  setProductSectionProductsInIds,
  updateProductSectionLoadedProductsIn,
  setSelectedProductSectionProductsFilters,
  completeProductSectionProductList,
};

export default connect(mapStateToProps, actionCreators)(ProductsContainer);
